<template>
    <!-- TEMPLATE FOR LISTING PAGE -->
    <!-- Limit to few contents only so that can be easily copied -->
    <div class="page-content mt-4">
        <pre>Reference : module/penyu/page-list.vue</pre>
        <breadcrumb class="bg-light pl-0" :items="breadcrumbs" />
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">Page for listing</h1>
            </div>
            <!-- SEARCH FUNCTION HERE -->
            <div class="col-md-6 pb-3">
                <input-search-icon
                    v-model="query"
                    :placeholder="'Search text'"
                    @search="searchFunction"
                >
                    <!-- To add element before search field -->
                    <template v-slot:before>
                        <button-three-dots></button-three-dots>
                        <button-date-picker class="mx-2"></button-date-picker>
                    </template>

                    <!-- To add element after search field -->
                    <template v-slot:after>
                        <button
                            type="button"
                            class="btn btn-secondary mx-2"
                            v-b-tooltip.hover.top
                            title="Add New Button"
                        >
                            <span class="fas fa-plus"></span>
                        </button>
                    </template>
                </input-search-icon>
            </div>
        </div>

        <!-- TABLE TEMPLATE -->
        <div class="card">
            <div class="card-body">
                <div class="table-holder table-responsive">
                    <table
                        class="table b-table list table-hover table-borderless"
                    >
                        <thead>
                            <tr>
                                <th>
                                    <sorting
                                        :order-by="'asc'"
                                        @sorting="triggerSorting"
                                        text="Header 1:"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        :order-by="null"
                                        @sorting="triggerSorting"
                                        text="Header 2:"
                                    >
                                    </sorting>
                                </th>
                                <th>Header 3:</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Data 1A</td>
                                <td>Data 2A</td>
                                <td>Data 3A</td>
                                <td class="text-right">
                                    <span class="action">Edit</span>
                                    <span>|</span>
                                    <span class="action">Delete</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Data 1B</td>
                                <td>Data 2B</td>
                                <td>Data 3B</td>
                                <td class="text-right">
                                    <span class="action">Duplicate</span>
                                    <span>|</span>
                                    <span class="action">Delete</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        inputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        ButtonDatePicker: () =>
            import("@/components/penyu/button-date-picker.vue"),
        Breadcrumb: () => import("@/components/commons/breadcrumb.vue"),
        ButtonThreeDots: () =>
            import("@/components/penyu/button-three-dots.vue"),
        Sorting: () => import("@/module/commons/sorting.vue")
    },
    data() {
        return {
            activeTab: "part1",
            navigations: [
                { label: "List", code: "part1" },
                { label: "Toggle", code: "part2" }
            ],
            greenToggle: true,
            query: "",
            breadcrumbs: [
                {
                    text: "Penyu",
                    to: {
                        name: "penyu"
                    }
                },
                {
                    text: "Page for listing",
                    to: ""
                }
            ]
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        searchFunction() {
            console.log("Searching something");
        },
        triggerSorting() {
            console.log("Trigger sorting");
        }
    }
};
</script>
